<template>

  <div v-if="establishments.length > 0">
    <br>
    <div class="field is-horizontal">
      <div class="field-body">
        <div class="field">
          <DropDown custom-classes="is-outlined"
                    v-on:dropdownClick="monthClicked"
                    :current-value="month"
                    :items="monthes"
                    shown-key="name"
                    default-label="Mois"></DropDown>
        </div>
        <div class="field">
          <DropDown custom-classes="is-outlined button-custom is-medium"
                    v-on:dropdownClick="yearClicked"
                    :current-value="year"
                    :items="years"
                    shown-key="name"
                    default-label="Année"></DropDown>
        </div>
        <div class="field" style="max-width:70px;">
          <a class="button button-custom is-outlined is-medium"
             style="height:52px!important;"
             :href="pdfLink"
             target="blank">
            <i class="fa fa-download"/>
            &nbsp;
            PDF
          </a>
        </div>
      </div>
    </div>

    <div class="is-pulled-right">
    </div>

    <div>
      <iframe v-if="reportLink" :src="reportLink" :style="{height: iframeHeight+'px'}"></iframe>
      <div class="message is-warning" v-else><br>
        <div class="message-body">Pas de rapport trouvé pour le mois sélectionné.
        </div>
      </div>
      <br>
      <br>
    </div>
  </div>
</template>


<script>
import moment from 'moment';
import settings from '@/settings.coffee';
import DropDown from '@/components/DropDown';

export default {
  name: "Reports",
  components: {
    DropDown
  },
  props: {
    establishments: Array,
    reports_access: Object,
    currentEstablishment: Object
  },
  data() {
    return {
      monthes: moment.months().map(el => ({ name: el })),
      month: null,
      year: null,
      reportLink: null,
      pdfLink: null
    };
  },
  computed: {
    lastreport() {
      return this.currentEstablishment.report_set[0];
    },
    years() {
      const ret = [];
      let year = 2019;
      while (year <= moment().year()) {
        ret.push({ name: year.toString() });
        year += 1;
      }
      return ret;
    },
    iframeHeight() {
      return 4000;
    }
  },
  methods: {
    getMonth(str) {
      return moment(str).format("MMMM YYYY");
    },
    getReportLink(uid) {
      return settings.backendUrl + "/admin/showreport/" + uid + "/";
    },
    monthClicked(month) {
      this.month = month;
      let found = false;
      for (const r of this.currentEstablishment.report_set) {
        const m = moment(r.period_start);
        if (m.format("YYYY") === this.year.name && m.format("MMMM") === this.month.name) {
          this.loadReport(r.uid);
          found = true;
        }
      }
      if (!found) {
        this.pdfLink = null;
        this.reportLink = null;
      }
    },
    yearClicked(year) {
      this.year = year;
      let found = false;
      for (const r of this.currentEstablishment.report_set) {
        const m = moment(r.period_start);
        if (m.format("YYYY") === this.year.name && m.format("MMMM") === this.month.name) {
          this.loadReport(r.uid);
          found = true;
        }
      }
      if (!found) {
        this.reportLink = null;
        this.pdfLink = null;
      }
    },
    loadReport(uid) {
      this.reportLink = this.getReportLink(uid);
      this.pdfLink = settings.backendMediaUrl + "reports/" + uid + ".pdf";
    }
  },
  mounted() {
    setTimeout(() => {
      new AcornIcons().replace();
      setTimeout(() => {
        $('.datepicker').datepicker({ autoclose: true, format: "dd/mm/yyyy" });
      }, 2000);
    }, 100);

    const m = moment(this.currentEstablishment.report_set[0].period_start);
    this.month = { name: m.format("MMMM") };
    this.year = { name: m.format("YYYY") };
    this.loadReport(this.currentEstablishment.report_set[0].uid);
  }
};
</script>


<style>
.button-custom {
  border-radius: 10px;
  height: 30px;
}

.is-primary.button-custom {
  background-color: var(--primary);
}

.is-primary.button-custom:hover {
  background-color: black;
}

.is-outlined.button-custom {
  border-color: var(--primary);
  color: var(--primary);
}

.is-outlined.button-custom:hover {
  border-radius: 10px;
  background-color: var(--primary);
  color: white;
  border-color: #b5b5b5;
}

.button-custom.is-medium {
  height: 40px !important;
  font-size: 15px;
}

iframe {
  width: 100%;

}
</style>
